import type { PropsWithChildren, ReactNode } from 'react'
import React, { memo } from 'react'

export interface LinkButtonProps {
  href: string
  icon: ReactNode
}

const LinkButton: React.FC<PropsWithChildren<LinkButtonProps>> = memo(
  ({ href, icon, children }) => {
    const isExternal = /^https?:\/\//.test(href)
    return (
      <a
        href={href}
        {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        className="flex items-center gap-4 w-full bg-white border border-teal-200 rounded-2xl px-4 py-4 shadow-sm hover:shadow-md hover:border-teal-400 transition-all"
      >
        <span className="shrink-0 w-10 h-10 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center p-2.5">
          {icon}
        </span>
        <span className="text-teal-800 font-semibold text-left leading-snug">
          {children}
        </span>
      </a>
    )
  },
)
LinkButton.displayName = 'LinkButton'

export default LinkButton
